import { CHEVRON_DOWN, CHEVRON_UP } from './icons.js';
import { queryAll, setExpanded } from './dom.js';

export function initInfoAccordion() {
  const items = queryAll('.info-accordion__item');
  if (!items.length) return;

  items.forEach(item => {
    const trigger = item.querySelector('.info-accordion__trigger');
    const panel   = item.querySelector('.info-accordion__panel');
    const icon    = trigger.querySelector('.info-accordion__icon');

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      setExpanded(trigger, !isOpen);
      item.classList.toggle('is-open', !isOpen);
      icon.innerHTML = isOpen ? CHEVRON_DOWN : CHEVRON_UP;
      panel.style.height = isOpen ? '0' : panel.scrollHeight + 'px';
    });
  });
}
